import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { Template } from 'crono-fe-common/types/template';

export const templateByIdQueryKey = (id: number) => [
  ENDPOINTS.template.main,
  id,
];

export default function useGetTemplateById(id: number | null | undefined) {
  const request: Request = {
    url: `${ENDPOINTS.template.main}?templateId=${id}`,
    config: {
      method: 'get',
    },
  };

  return useQuery<Response<Template>, CronoError>({
    queryKey: templateByIdQueryKey(id!),
    queryFn: () => client(request),
    enabled: !!id,
  });
}
